import React from 'react';

import { OrderType } from 'enums';
import { Statistics } from 'features/statistics';

export const AdminPayinStatisticsPage: React.FC = () => (
  <Statistics orderType={OrderType.Payin} />
);
export const AdminPayoutStatisticsPage: React.FC = () => (
  <Statistics orderType={OrderType.Payout} />
);
